import { Grid, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { LICENSE_CHAGES_TYPE } from 'app/config/services';
import React, { useMemo } from 'react';
import InfoLicenses from '../InfoLicenses';

const InfoRequest = (props) => {
    const { oldRequest, oldService, classes, selectedChangeType } = props;

    const nmService = useMemo(() => {
        if (oldService?.nmServico) {
            return oldService.nmServico;
        }
        if (oldRequest?.servico?.nmServico) {
            return oldRequest?.servico?.nmServico;
        }
        return '';
    }, [oldRequest, oldService]);

    const infoServiceData = {
        [LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO]: {
            title: `Solicitação de Substituição de veículo`,
            changeTitle: `Substituição de veículo`,
            description: `Para substituir o veículo na licença, é necessário que o veículo já esteja cadastrado na AGERBA (serviço de inclusão de veículo) e com vistoria (serviço de vistoria)`,
            titleSection: `Veículo anterior a ser substituído`,
        },
        [LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO]: {
            title: `Solicitação Mudança de contrato`,
            changeTitle: `Mudança de contrato`,
            description: null,
            titleSection: null,
        },
        [LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL]: {
            title: `Solicitação Mudança razão social da empresa`,
            changeTitle: `Mudança razão social da empresa`,
            description: `Para alterar a 'Razão social da empresa' na licença, primeiro é necessário realizar o serviço de 'Alteração cadastral com emissão de CRC'.`,
            titleSection: null,
        },
        [LICENSE_CHAGES_TYPE.ALTERAR_PROPRIETARIO_VEICULO]: {
            title: `Solicitação Alterar proprietário do veículo`,
            changeTitle: `Alterar proprietário do veículo`,
            description: `Para alterar o 'Proprietário' e/ou 'Município' do veículo na licença, primeiro é necessário alterar as informações do veículo (serviço de 'Alterar dados do veículo')`,
            titleSection: `Informações atuais na licença`,
        },
        [LICENSE_CHAGES_TYPE.MUDANCA_MUNICIPIO_VEICULO]: {
            title: `Solicitação Mudança Município do veículo`,
            changeTitle: `Mudança Município do veículo`,
            description: `Para alterar o 'Proprietário' e/ou 'Município' do veículo na licença, primeiro é necessário alterar as informações do veículo (serviço de 'Alterar dados do veículo')`,
            titleSection: `Informações atuais na licença`,
        },
        [LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO]: {
            title: `Solicitação Mudança de itinerário`,
            changeTitle: `Mudança de itinerário`,
            description: null,
            titleSection: null,
        },
    };

    return (
        <>
            <Grid item xs={12}>
                <h3 className={classes.title}>{infoServiceData[selectedChangeType]?.title}</h3>
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    name=""
                    label="Tipo de alteração"
                    margin="dense"
                    variant="filled"
                    fullWidth
                    disabled
                    value={infoServiceData[selectedChangeType]?.changeTitle}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    name=""
                    label="Tipo de Licença"
                    margin="dense"
                    variant="filled"
                    fullWidth
                    disabled
                    value={nmService}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Grid>

            {infoServiceData[selectedChangeType]?.description && (
                <Grid item xs={12}>
                    <Alert severity="info">
                        <b>Importante</b>
                        <br />
                        {infoServiceData[selectedChangeType]?.description}
                    </Alert>
                </Grid>
            )}

            {infoServiceData[selectedChangeType]?.titleSection && (
                <Grid item xs={12}>
                    <h3 className={classes.yellowTitle}>{infoServiceData[selectedChangeType]?.titleSection}</h3>
                </Grid>
            )}

            {(Number(selectedChangeType) === LICENSE_CHAGES_TYPE.MUDANCA_ITINERARIO ||
                Number(selectedChangeType) === LICENSE_CHAGES_TYPE.MUDANCA_CONTRATO ||
                Number(selectedChangeType) === LICENSE_CHAGES_TYPE.MUDANCA_RAZAO_SOCIAL) && <InfoLicenses {...props} />}
        </>
    );
};

export default InfoRequest;
